import { createLayout, type Layout } from '@atlassian/jira-route-layout/src/index.tsx';

export const chromelessLayout: Layout = createLayout({ isChromeless: true });
